import styled, { css } from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

interface IMenuProps {
  activeMenu: boolean;
}

export const Container = styled.ul`
  width: 90%;
`;

export interface IShowMenu {
  show: boolean;
  active?: boolean;
}

interface IOptMenuProps extends IShowMenu {
  collapsed?: boolean;
  submenuOpen?: boolean;
}

export const OptMenu = styled.li<IOptMenuProps>`
  list-style: none;
  background-color: ${({ active }) =>
    active ? `${colors.primary}1f` : 'transparent'};
  width: 100%;
  height: 40px;
  margin-top: 8px;

  position: relative;

  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: ${radius.DEFAULT};
  padding: 0 8px;

  transition: background-color 0.2s;

  cursor: pointer;

  overflow-x: hidden;

  &:hover {
    background-color: ${colors.surfaceContainerHigh};
  }

  .chevron,
  .lock {
    position: absolute;
    right: 8px;
  }

  .chevron {
    transition: transform 0.25s ease;
    transform: rotate(
      ${({ submenuOpen }) => (submenuOpen ? '180deg' : '0deg')}
    );
  }

  .label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ active }) =>
      active ? colors.primary : colors.onSurfaceVariant};
  }

  ${({ collapsed }) =>
    collapsed &&
    css`
      justify-content: center;
      padding: 0;

      .chevron,
      .lock {
        display: none;
      }

      .label {
        display: none;
      }
    `}
`;

interface ISubmenuProps {
  activeSubmenu: boolean;
}

// Truque do grid-template-rows 0fr/1fr pra animar uma altura que
// depende do conteúdo (nº de itens do submenu varia) sem JS medindo
// altura -- `display: none`/`flex` de antes trocava de estado
// instantaneamente, sem transição possível.
export const SubmenuWrapper = styled.div<ISubmenuProps>`
  display: grid;
  grid-template-rows: ${props => (props.activeSubmenu ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease;
`;

export const Submenu = styled.ul`
  overflow: hidden;
  min-height: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  list-style: none;
`;

export const OptSubmenu = styled.li<IShowMenu>`
  margin: 0;

  display: flex;

  align-items: center;
  width: 100%;
  min-height: 36px;
  background-color: transparent;
  border-radius: ${radius.DEFAULT};
  list-style: none;

  overflow-x: hidden;

  transition: background-color 0.2s;

  cursor: pointer;

  &:hover {
    background-color: ${colors.surfaceContainerHigh};
  }

  span {
    font-size: 13px;
    color: ${({ active }) =>
      active ? colors.primary : colors.onSurfaceVariant};
    font-weight: ${({ active }) => (active ? 700 : 400)};
    // Mais recuo que antes (10px) -- diferença visual maior em relação
    // ao texto dos itens principais do menu, deixando a hierarquia
    // pai/filho mais clara à primeira vista.
    margin-left: 28px;
  }

  .lock {
    margin-left: auto;
    margin-right: 10px;
  }

  ${props =>
    props.show
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}
`;
